import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import PeopleIcon from "@mui/icons-material/People";
import TableChartIcon from "@mui/icons-material/TableChart";
import TodayIcon from "@mui/icons-material/Today";
import { Box, Card, Grid, Typography } from "@mui/material";
import { push } from "connected-react-router";
import * as React from "react";
import { useDispatch } from "react-redux";
import { tl } from "../../components/translate";
import Can from "../Policy/Can";
import mixpanelAnalytics from "../../mixpanel-analytics/mixpanelAnalytics";
import EVENT from "../../mixpanel-analytics/event";
import useCurrentResourceCentre from "../../hooks/useCurrentResourceCentre";
import { reportCardStyle, reportsCardContainerStyle } from "./ReportTypesList";

// @ts-expect-error - css
import styles from "./Reports.module.css";
import useModuleSubscriptions from "../../hooks/useModuleSubscriptions";

const ReportsPatient = (): React.JSX.Element => {
  const dispatch = useDispatch();

  // custom hooks
  const rc = useCurrentResourceCentre();
  const { isOpdSubscribed } = useModuleSubscriptions();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ ...reportsCardContainerStyle }}>
        <Can policyAccessKey="report:patientFlowReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_PATIENT_APPOINTMENT, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/patient/appointmentReport"));
            }}
            data-testmation="patientFlowReportCard"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography fontWeight="700" fontSize="24px" component="span">
                    {tl("reports.appointmentReport")}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <TableChartIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>

        {isOpdSubscribed && (
          <Can policyAccessKey="report:patientAssessmentReport">
            <Card
              sx={{ ...reportCardStyle }}
              onClick={() => {
                mixpanelAnalytics.track(EVENT.REPORT_GO_TO_PATIENT_PRESCRIPTION, {
                  rcId: rc.id,
                  rcName: rc.name
                });
                return dispatch(push("/reports/patient/patientAssessmentReport"));
              }}
              data-testmation="patientAssessmentReportCard"
            >
              <Grid container>
                <Grid size={8}>
                  <Box height="100%" width="100%">
                    <Typography fontWeight="700" fontSize="24px" component="span">
                      {tl("reports.patientAssessmentReport")}
                    </Typography>
                  </Box>
                </Grid>
                <Grid size={4}>
                  <BubbleChartIcon className={styles.reportCardChartIcon} />
                </Grid>
              </Grid>
            </Card>
          </Can>
        )}

        <Can policyAccessKey="report:patientFlowReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_PATIENT_CLIENT, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/patient/clientReport"));
            }}
            data-testmation="clientReportCard"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography fontWeight="700" fontSize="24px" component="span">
                    {tl("reports.clientReport")}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <PeopleIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="report:patientFlowReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_PATIENT_REMINDERS, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/patient/reminders"));
            }}
            data-testmation="clientReportCard"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography fontWeight="700" fontSize="24px" component="span">
                    {tl("reports.reminders")}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <TodayIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="report:patientFlowReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_SERVICE_PROVIDER_STATISTICS_REPORT, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/patient/serviceProviderStatisticsReport"));
            }}
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography fontWeight="700" fontSize="24px" component="span">
                    {tl("reports.serviceProviderStatisticsReport")}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <TodayIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
      </Box>
    </Box>
  );
};

export default ReportsPatient;
